import { render, staticRenderFns } from "./DataSummary.vue?vue&type=template&id=0940518a&scoped=true"
import script from "./DataSummary.vue?vue&type=script&lang=js"
export * from "./DataSummary.vue?vue&type=script&lang=js"
import style0 from "./DataSummary.vue?vue&type=style&index=0&id=0940518a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0940518a",
  null
  
)

export default component.exports